import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { getQuery } from '@blaze-cms/admin-ui-utils';
import { Checkbox } from '@blaze-react/checkboxes';

const MENU_PERMISSIONS = ['update:any', 'update:own', 'create:any', 'create:own'];

const SearchAdminSideBar = ({
  searchModalSideBarClassName,
  openSearchSideBar,
  setOpenSearchSideBar,
  handleSetEntityValues,
  entityValues,
  setEntityValues
}) => {
  const [loadMore, setLoadMore] = useState(false);
  const { data: { getEntitySchemas = [] } = {}, loading } = useQuery(
    getQuery('GET_USER_EDITABLE_ENTITIES'),
    {
      variables: {
        canDoActions: MENU_PERMISSIONS
      }
    }
  );

  if (loading) return null;

  const filteredEntitiesSchemas = getEntitySchemas.filter(entity => {
    if (entity.extras && entity.extras.searchIndexes) {
      return entity.extras.searchIndexes.includes('admin');
    }
    return false;
  });

  const entitiesToShow = filteredEntitiesSchemas.slice(
    0,
    loadMore ? filteredEntitiesSchemas.length : 5
  );

  return (
    <div className={searchModalSideBarClassName}>
      <div
        className="modal__search__sidebar__button"
        role="button"
        onClick={() => setOpenSearchSideBar(!openSearchSideBar)}>
        <i className="material-icons">
          {openSearchSideBar ? 'keyboard_arrow_left' : 'keyboard_arrow_right'}
        </i>
      </div>
      <div className="modal__search__sidebar__container">
        <div className="modal__search__sidebar__wrapper">
          <div className="modal__search__sidebar__filters">
            <i className="material-icons modal__search__sidebar__icon">tune</i>
            <span>Filters</span>
          </div>
          <div
            className="modal__search__sidebar__clear"
            role="button"
            onClick={() => setEntityValues([])}>
            <span>Clear all</span>
            <i className="material-icons modal__search__sidebar__icon--clear">replay</i>
          </div>
        </div>
        <div className="modal__search__sidebar__entity-list">
          <h1>Entity list</h1>
          {entitiesToShow.map(entity => (
            <Checkbox
              checked={entityValues.some(_entity => _entity.id === entity.id)}
              label={entity.displayName}
              id={entity.id}
              name={entity.id}
              onChange={({ value: { checked } }) => handleSetEntityValues(entity)}
            />
          ))}
          <div
            className="modal__search__sidebar__more"
            role="button"
            onClick={() => setLoadMore(!loadMore)}>
            <i className="material-icons">{!loadMore ? 'navigate_next' : 'expand_less'}</i>
            <span>{loadMore ? 'Less' : 'More'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchAdminSideBar;
